export const valoresKangu = {
  0: {
    key: 2.18,
    value: '27 x 22 x 22',
    altura: 27,
    largura: 22,
    comprimento: 22,
  },
  1: {
    key: 7.18,
    value: '42 x 32 x 32',
    altura: 42,
    largura: 32,
    comprimento: 32,
  },
  2: {
    key: 10.37,
    value: '43 x 38 x 38',
    altura: 43,
    largura: 38,
    comprimento: 38,
  },
  3: {
    key: 18.04,
    value: '60 x 45 x 40',
    altura: 60,
    largura: 45,
    comprimento: 40,
  },
  4: {
    key: 0.31,
    value: '12 x 9 x 17',
    altura: 12,
    largura: 9,
    comprimento: 17,
  },
  5: {
    key: 0.69,
    value: '22 x 11 x 17',
    altura: 22,
    largura: 11,
    comprimento: 17,
  },
  6: {
    key: 0.06,
    value: '12 x 6 x 5',
    altura: 12,
    largura: 6,
    comprimento: 5,
  },
  7: {
    key: 0.38,
    value: '25 x 15 x 6',
    altura: 25,
    largura: 15,
    comprimento: 6,
  },
  8: {
    key: 4.98,
    value: '43 x 33 x 21',
    altura: 43,
    largura: 33,
    comprimento: 21,
  },
}
